<template>
  <span class="row ship">
      <span class="wrapper">
        <img class="ship-img" :src="`../../static/img/${opp}/ships/${ship.boat.code}/ship.svg`"/>
        <img class="spot" :src="`../../static/img/${opp}/ships/${ship.boat.code}/ship_spot.svg`"/>
        <img v-if="positions" class="work" v-for="job in ship.boat.zones" :key="job.id" :src="`../../static/img/${opp}/ships/${ship.boat.code}/${job.code}.svg`"
            :style="{bottom: positions[opp][ship.boat.code][job.code].bottom + '%', left: positions[opp][ship.boat.code][job.code].left + '%'}"
            @click="$emit('click', job.code)"/><!--  :style="{bottom: '45.5%', left: 20.39 + '%', transform: 'translateX(-50%)'}"/> -->
        <!-- <img class="work" :src="`../../static/img/${opp}/ships/${ship.boat.code}/work1.svg`" :style="{bottom: '61.5%', left: 67.45 + '%', transform: 'translateX(-50%)'}"/> -->
      </span>
  </span>
</template>
<script>
import pos from './shipJobsPositions'
export default {
  name: 'ship',
  props: ['opp', 'ship'],
  mounted () {
    this.positions = pos
    console.log(this.ship.boat)
  },
  data () {
    return {
      positions: undefined
    }
  }
}
</script>
<style lang="scss">
.row.ship {
    margin: 0;
}
.wrapper{
    flex-basis: 90%;
    position: relative;
    display: inline-block;
    width:100vw;
    max-width: 600px;
    margin: 2em 1em 0 1em;
}
.ship-img {
    width:100%;
}
.spot {
    position: absolute;
    width:100%;
    top: 0;
    left: 0;
    z-index: -1;
}
.work {
    position: absolute;
    width:13%;
    transform: translateX(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/ship.vue